import {getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import type {VerticalListSelectProps} from './VerticalListSelect';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getLayouts(props: VerticalListSelectProps) {
    const responsiveContainer = Store.computed(() => {
        const responsive = getProp(props.responsive, {} as ResponsiveConf);

        responsive.box ??= {};
        responsive.box.width = getProp(props.width);
        responsive.box.height = getProp(props.height);

        return responsive;
    });

    return {
        responsiveContainer,
    };
}
